<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-17 15:58:50
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:15:54
-->
<template>
   <div>
     <div class="head">
        <div style="display: flex; align-items: center">
          <div  class="back" @click="toBack"><a-icon type="arrow-left" /></div>
          <div   style="font-size: 18px; color: #303133; font-weight: bold">
            &emsp;新增问卷
          </div>
        </div>
      </div>
       <div class="top">
          <div class="log-box">
                <!-- <div
                  @click="changeType(1)"
                    v-if="codeData.indexOf('295') != -1"
                  :style="{ color: type == 1 ? '#1890FF' : '' }"
                  class="log"
                >
                  问卷设置
                </div>
                <div
                v-if="codeData.indexOf('300') != -1 && isShow"
                  @click="changeType(2)"
                  :style="{ color: type == 2 ? '#1890FF' : '' }"
                  class="log"
                >
                  问卷内容
                </div> -->
                 <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane v-if="codeData.indexOf('295') != -1" label="问卷设置" name="first"></el-tab-pane>
                    <el-tab-pane  v-if="codeData.indexOf('300') != -1 && isShow" label="问卷内容" name="second"></el-tab-pane>
                  </el-tabs>
      </div>
       </div>
       <QuestionnaireSetting @content="content" v-if="type == 1 && codeData.indexOf('295') != -1"/>
       <QuestionnaireContent v-if="type == 2 && isShow && codeData.indexOf('300') != -1"/>
   </div>
</template>

<script>
import QuestionnaireSetting from './questionnaire_siting.vue';
import QuestionnaireContent from './questionnaire_content.vue';
export default {
   data(){
      return {
          type:1,
          codeData:[],
          isShow:false,
          activeName:'first',
      }
   },
   components:{
      QuestionnaireSetting,
      QuestionnaireContent,
   },
   mounted(){
      this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
      if(this.codeData.indexOf('295') == -1){
          this.type = 2;
          this.activeName = 'second'
          return;
      }
   },
   methods:{
      changeType(type){
            this.type = type;
      },
       handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
            this.changeType(1)
        }
         if(this.activeName == 'second'){
            this.type = 2;
            this.changeType(2)
        }
      },
       toBack() {
        this.$router.push({
        path: "/index/questionnaire",
      });
    },
    content(){
        this.isShow = true;
    }
   }
}
</script>

<style lang="less" scoped>
.top{
   padding: 24px;
   padding-bottom: 0px;
    /deep/ .el-tabs__header{
    margin: 0px;
   }
}
   .log-box {
    //border-bottom: solid 1px #dcdfe6;
    //display: flex;
    color: #000;
    // .log {
    //   padding: 10px 20px;
    //   border-top: solid 1px #dcdfe6;
    //   border-left: solid 1px #dcdfe6;
    //   cursor: pointer;
    // }
    // .log:last-child {
    //   border-right: solid 1px #dcdfe6;
    //   border-top-right-radius: 10px;
    // }
    // .log:first-child {
    //   border-top-left-radius: 10px;
    // }
  }
   .head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
  padding: 18px 24px;
}
.back{
  cursor: pointer;
}
</style>